import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CONTACT_ADDRESS_EDIT_FORM_SCHEMA = yup.object().shape({
  country: yup.string().required('Molimo Vas da unesete država'),
  city: yup.string().required('Molimo Vas da unesete grad'),
  state: yup.string().required('Molimo Vas da unesete općinu'),
  // postalCode: yup.string().required('Molimo Vas da unesete poštanski broj'),
});

